import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Backdrop,
  Button,
  Chip,
  CopyToClipboard,
  DocumentsList,
  HeaderCard,
  InfoCardNewAdv,
  KeyValue,
  LogoLoader,
  Modal,
  TableAdv,
  VoidModal,
  ApInvoicesHeader,
} from "../../../../components";
import { dateFormator, mapTableRows } from "../../../../utils";
import { useDispatch, useSelector } from "react-redux";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import { formatCurrency } from "../../../../utils/stringUtils";
import ReceivePayment from "../../Invoices/Invoices/ReceivePayment";
import {
  clearAccountPayablesData,
  getAccountPayablesOneStart,
} from "../../../../redux/slices/accountPayables/accountPayablesSlice";

const ApInvoiceDetails = ({
  onBack,
  invoiceUiid,
  removeButtonForPreview = false,
  isPublicView = false,
  companyLogo: propCompanyLogo,
  fromModal = true,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userData: loginUserData } = useLoginUser();

  const currentAccountsPayables = useSelector(
    (state) => state.accountPayables.currentAccountPayables.details,
  );
  const loading = useSelector((state) => state.accountPayables.loading);

  const [attachmentModal, setAttachmentModal] = useState(false);
  const [showReceivePayment, setShowReceivePayment] = useState(false);
  const [isVoidModalOpen, setIsVoidModalOpen] = useState(false);

  useEffect(() => {
    if (invoiceUiid) {
      dispatch(
        getAccountPayablesOneStart({
          accountPayableUiid: invoiceUiid,
          ref: "Employee Vendor Document Approver InvClient InvVendor",
          incl: [
            "firstName lastName employmentType",
            "businessName",
            "",
            "firstName lastName employementType",
            "businessName uiid",
            "businessName uiid",
          ],
        }),
      );
    }
    // return () => {
    //   dispatch(clearAccountPayablesData());
    // };
  }, [invoiceUiid]);

  const columns = [
    {
      key: "service",
      label: "Product / Service",
      render: (row) => (
        <div className="flex items-center gap-3 group">
          <div>{row?.service || "-"}</div>
          <div
            className={`flex items-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 ${
              !row?.service ? "invisible" : "visible"
            }`}
          >
            <CopyToClipboard
              tooltipPosition="right"
              title="Product / Service"
              content={row?.service}
            />
          </div>
        </div>
      ),
    },
    {
      key: "description",
      label: "Description",
      render: (row) => (
        <div className="flex items-center gap-3 group">
          <div>{row?.description || "-"}</div>
          <div
            className={`flex items-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 ${
              !row?.description ? "invisible" : "visible"
            }`}
          >
            <CopyToClipboard
              tooltipPosition="right"
              title="Description"
              content={row?.description}
            />
          </div>
        </div>
      ),
    },
    {
      key: "quantity",
      label: "Quantity",
      render: (row) =>
        isNaN(row.quantity) ? "-" : Number(row.quantity).toFixed(2),
    },
    {
      key: "rate",
      label: "Rate",
      render: (row) => formatCurrency(row.rate),
    },
    {
      key: "amount",
      label: "Amount",
      width: "180px",
      render: (row) => formatCurrency(row.amount),
    },
  ];

  const tableData = currentAccountsPayables?.invoiceDetails || [];
  const mappedRows = mapTableRows(tableData, columns);

  const docs = (currentAccountsPayables?.documents || []).flatMap((doc) =>
    (doc.file || []).flatMap((f) =>
      (f.keys || []).map((k) => ({ name: f.name, filePath: k })),
    ),
  );

  const handleQbSync = async () => {
    console.log("clicked on handleQbSync");
  };
  const closeVoidModal = () => {
    setIsVoidModalOpen(false);
  };
  return (
    <div className="flex-1 w-full flex overflow-auto">
      {showReceivePayment ? (
        <ReceivePayment onBack={() => setShowReceivePayment(false)} />
      ) : (
        <div
          className="flex-1 flex flex-col overflow-auto pr-1"
          id="ap-invoice-wrapper"
        >
          <Backdrop isOpen={loading}>
            <LogoLoader />
          </Backdrop>

          <div className="flex flex-col gap-6 my-1">
            <div className="inputShadow p-3 pt-0 flex flex-col gap-1">
              {!removeButtonForPreview && (
                <div>
                  <Button
                    title="Back"
                    icon="west"
                    size="sm"
                    color="black"
                    variant="text"
                    className="!px-0 hover:bg-transparent"
                    onClick={onBack}
                  />
                </div>
              )}

              {isPublicView ? (
                <div className="grid grid-cols-3 items-center">
                  <div className="flex justify-start mt-2">
                    <img
                      src={propCompanyLogo}
                      alt="Company Logo"
                      style={{ height: "60px", objectFit: "contain" }}
                    />
                  </div>
                  <div className="flex justify-center mt-2">
                    {loginUserData?.organizationId?.logo?.company && (
                      <img
                        src={loginUserData?.organizationId?.logo?.company}
                        alt="Organization Logo"
                        style={{ height: "64px", objectFit: "contain" }}
                      />
                    )}
                  </div>
                </div>
              ) : (
                <div className="flex justify-between items-center">
                  {/* <div className="flex flex-col gap-0.5">
                    <span className="text-sm font-medium text-gray-500">
                      AP Invoice
                    </span>
                    <span
                      className="text-base font-semibold"
                      style={{
                        background: "rgba(255,190,0,0.2)",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        display: "inline-block",
                      }}
                    >
                      {currentAccountsPayables?.invoiceNum || "-"}
                    </span>
                  </div> */}
                  <div>
                    <ApInvoicesHeader
                      data={{
                        // logo: companyLogo,
                        title: "Tektree",
                        invoiceNumber: (
                          <span
                            style={{
                              background: "rgba(255, 190, 0, 0.2)",
                              padding: "2px 4px",
                              borderRadius: "4px",
                            }}
                          >
                            {currentAccountsPayables?.invoiceNum}
                          </span>
                        ),
                        syncStatus:
                          currentAccountsPayables?.qbSync?.status || 1,
                        invoiceStatus:
                          currentAccountsPayables?.status == 1
                            ? "Saved"
                            : "Submitted",
                      }}
                    />
                  </div>

                  <div className="min-w-60">
                    <InfoCardNewAdv
                      layout="option12"
                      title={
                        (currentAccountsPayables?.amounts?.due ?? 0) >= 0
                          ? "Total Due"
                          : "Excess Payment"
                      }
                      value={
                        formatCurrency(currentAccountsPayables?.amounts?.due) ??
                        0
                      }
                      valueConfig={{ className: "text-[20px]!" }}
                      suffix="USD"
                      suffixConfig={{ className: "font-normal! mt-1!" }}
                    />
                  </div>
                </div>
              )}
              {!removeButtonForPreview && (
                <div className="flex justify-end gap-1.5" data-print="false">
                  <Button
                    size="sm"
                    variant="outlined"
                    color="black"
                    title={"Update to QB"}
                    icon={"arrow_left_alt"}
                    disabled={true}
                    // onClick={() => handleQB("invoices")}
                  />
                  <Button
                    size="sm"
                    variant="outlined"
                    color="black"
                    title={"Sync from QB"}
                    icon={"autorenew"}
                    onClick={() => handleQbSync()}
                  />
                  <Button
                    size="sm"
                    variant="outlined"
                    color="black"
                    title={"Void Invoice"}
                    icon={"block"}
                    onClick={() => setIsVoidModalOpen(!isVoidModalOpen)}
                  />
                  <Button
                    size="sm"
                    type="icon"
                    variant="outlined"
                    color="black"
                    icon={"delete"}
                    className="rounded-sm p-4 px-5 text-danger-200"
                  />
                </div>
              )}
            </div>

            <div className="grid grid-cols-2 gap-5">
              <HeaderCard
                title="Bill From"
                className="!bg-primary-50 !text-primary"
              >
                <KeyValue
                  oneLine={false}
                  label={currentAccountsPayables?.vendorId?.businessName || "-"}
                  value={
                    <div className="whitespace-pre-line">
                      {currentAccountsPayables?.mailAddress || "-"}
                    </div>
                  }
                />
              </HeaderCard>

              <HeaderCard
                title="Invoice Details"
                className="!bg-primary-50 !text-primary"
              >
                <div className="flex flex-col gap-1">
                  <KeyValue
                    label="Invoice #"
                    value={
                      <span
                        style={{
                          backgroundColor: "rgba(255,190,0,0.2)",
                          padding: "2px 4px",
                          borderRadius: "4px",
                        }}
                      >
                        {currentAccountsPayables?.invoiceNum}
                      </span>
                    }
                  />
                  <KeyValue
                    label="Invoice Date"
                    value={
                      currentAccountsPayables?.invoiceDate
                        ? dateFormator(currentAccountsPayables.invoiceDate)
                        : "-"
                    }
                  />
                  <KeyValue
                    label="Bill Date"
                    value={
                      currentAccountsPayables?.billedDate
                        ? dateFormator(currentAccountsPayables.billedDate)
                        : "-"
                    }
                  />
                  <KeyValue
                    label="Due Date"
                    value={
                      currentAccountsPayables?.dueDate
                        ? dateFormator(currentAccountsPayables.dueDate)
                        : "-"
                    }
                  />
                  <KeyValue
                    label="Terms"
                    value={currentAccountsPayables?.netTerms}
                  />
                  {/* <KeyValue
                    label="Vendor"
                    value={
                      currentAccountsPayables?.vendorId?.businessName || "-"
                    }
                  /> */}
                  <KeyValue
                    label="Employee(s)"
                    value={
                      (currentAccountsPayables?.employeeId || [])
                        .map((e) =>
                          `${e.firstName || ""} ${e.lastName || ""}`.trim(),
                        )
                        .join(", ") || "-"
                    }
                  />
                </div>
              </HeaderCard>
            </div>

            <div className="inputShadow p-3 w-full">
              <div className="shadow-md">
                <TableAdv
                  rows={mappedRows}
                  columns={columns}
                  hideToolBar
                  showSlNo
                />
              </div>

              {/* Totals */}
              <div className="flex justify-end">
                <div className="my-2 grid grid-cols-[1fr_190px] gap-x-10 w-fit max-w-2xl text-sm">
                  <div className="py-2">Subtotal</div>
                  <div className="py-2">
                    {formatCurrency(currentAccountsPayables?.amounts?.billed)}
                  </div>
                  <div className="col-span-2 border-t border-gray-200" />

                  {/* Discounts */}
                  {(currentAccountsPayables?.discount || []).length > 0 && (
                    <>
                      {[...(currentAccountsPayables.discount || [])]
                        .reverse()
                        .map((discount, index) => (
                          <React.Fragment key={discount?._id || index}>
                            <div className="py-2">{discount?.name}</div>
                            <div className="py-2">
                              {discount?.type === 1
                                ? `-${formatCurrency(
                                    Math.round(
                                      Number(
                                        currentAccountsPayables?.amounts
                                          ?.billed,
                                      ) * Number(discount.value),
                                    ) / 100,
                                  )}`
                                : `-${formatCurrency(discount?.value)}`}
                            </div>
                            <div className="col-span-2 border-t border-gray-200" />
                          </React.Fragment>
                        ))}
                    </>
                  )}

                  <div className="py-2 font-medium">Invoice Total</div>
                  <div className="py-2 font-medium">
                    {formatCurrency(currentAccountsPayables?.amounts?.billed)}
                  </div>
                  <div className="col-span-2 border-t border-gray-200" />

                  {(currentAccountsPayables?.amounts?.due ?? 0) > 0 && (
                    <>
                      <div className="py-2 text-primary text-base font-medium">
                        Balance Due
                      </div>
                      <div className="py-2 text-primary text-base font-medium">
                        {formatCurrency(currentAccountsPayables?.amounts?.due)}
                      </div>
                    </>
                  )}

                  {(currentAccountsPayables?.amounts?.paid ?? 0) > 0 && (
                    <>
                      <div className="py-2 text-success text-base font-medium">
                        Paid
                      </div>
                      <div className="py-2 text-success text-base font-medium">
                        {formatCurrency(currentAccountsPayables?.amounts?.paid)}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {!isPublicView && (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
                <div className="inputShadow p-3 flex flex-col gap-2">
                  <KeyValue
                    label="Statement Memo"
                    className="text-primary"
                    value={currentAccountsPayables?.memo}
                  />
                  <KeyValue
                    label="Comments"
                    className="text-primary"
                    value={currentAccountsPayables?.comments}
                  />
                </div>

                <div className="inputShadow p-3 flex justify-between items-center">
                  <Chip
                    className="cursor-pointer"
                    label={`Attachments: ${docs.length}`}
                    variant="text"
                    color="primary"
                    icon="attach_file"
                    iconPosition="before"
                    disabled={docs.length <= 0}
                    onClick={() => setAttachmentModal(true)}
                  />
                </div>
              </div>
            )}

            {!removeButtonForPreview && (
              <div className="flex justify-end gap-2" data-print="false">
                <Button
                  title="Receive Payment"
                  size="sm"
                  variant="outlined"
                  onClick={() => setShowReceivePayment(true)}
                />
                <Button
                  title="Edit"
                  size="sm"
                  variant="outlined"
                  onClick={() =>
                    navigate(`/accounts-payable/edit/${invoiceUiid}`, {
                      state: { code: invoiceUiid, edit: true, fromModal },
                    })
                  }
                />
                <Button
                  title="Cancel"
                  size="sm"
                  variant="outlined"
                  onClick={onBack}
                />
              </div>
            )}
          </div>
          <VoidModal open={isVoidModalOpen} onClose={closeVoidModal} />

          <Modal
            isOpen={attachmentModal}
            onClose={() => setAttachmentModal(false)}
            width="max-w-2xl"
            title="Document Details"
          >
            <DocumentsList data={docs} />
          </Modal>
        </div>
      )}
    </div>
  );
};

export default ApInvoiceDetails;
